















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import { date } from '@/util/adapter';
import storage from 'baimahu/storage';
const uuidv4 = require('uuid/v4');
const getUrl = require('bmh/url-with-param');
const dateFormat = require('bmh/date-format');
const profile = storage.getItem('profile') || {};
const merchant_id = profile.merchant_id || '';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_FCREST: FCREST } = process.env;
const API = {
  activity_info: `${FCREST}/promotion/shang/activity/`,
  general_situation: `${FCREST}/promotion/shang/live/clerk/statistics`,
  total_general_situation: `${FCREST}/promotion/shang/live/clerk/statistics/`,
  export: `${FCREST}/promotion/shang/live/clerk/statistics?`,
  sign_up: `${FCREST}/promotion/shang/live/visitor/visit`,
  get_setting_info: `${FCAPI}/shang/setting/profile/${merchant_id}`,
  export_sign: `${FCREST}/promotion/shang/live/visitor/visit`,
};

function getPagingData(remote?: RemotePagination<any>) {
  remote = (remote || {}) as RemotePagination<any>;
  const current = remote.current_page;
  return {
    current: +current || 1,
    data: remote.data || [],
    last: remote.last_page || 1,
    size: remote.per_page || 1,
    total: remote.total || 0,
  };
}

interface SettingInfo {
  guide_to_wx_id: string;
  guide_to_wx_qrcode: string;
  logo: string;
  mobile: string;
  role_name: string;
  role_name_two: string;
  specify_ware_name: string;
  wxapp_name: string;
}
function getSettingInfo(remote: SettingInfo) {
  remote = remote || {};
  return {
    guide_to_wx_id: remote.guide_to_wx_id || '',
    guide_to_wx_qrcode: remote.guide_to_wx_qrcode || '',
    logo: remote.logo || '',
    mobile: remote.mobile || '',
    role_name: remote.role_name || '合伙人',
    role_name_two: remote.role_name_two || '大使',
    specify_ware_name: remote.specify_ware_name || '',
    wxapp_name: remote.wxapp_name || '',
  };
}

@Component
export default class ActivityConfig extends Vue {
  activity_id: string = '';
  activity: any = {};
  detail_data: any = getPagingData();
  general_situation_data: any = getPagingData();
  general_situation_page: number = 1;
  is_loading: boolean = false;
  level: string = '1';
  moment: Moment[] = [];
  now_timestamp: number = 0;
  sign_up_page: number = 1;
  send_data: any = {};
  setting_info: any = {};
  // 格式化日期
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  // 切换等级
  async changeLevel(level: string) {
    this.general_situation_data = getPagingData();
    this.level = level;
    await this.getGeneralSituationInfo(this.general_situation_page, this.level);
    await this.getTotalInfo(this.level);
  }

  // 控制页码显示
  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.size}条`,
      pageSize: data.size || 1,
      current: data.current || 1,
    };
  }
  // 加载其他页概况信息
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getGeneralSituationInfo(next_page, this.level);
  }
  // 加载其他页概况信息
  handChangeDetailPage(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getSignUpInfo(next_page);
  }

  // 获取活动信息
  async getActivityInfo() {
    this.is_loading = true;
    const _data = await this.$axios.get(
      `${API.activity_info}${this.activity_id}`,
    );
    this.is_loading = false;
    if (_data.status !== 200) {
      this.$message.error(_data.data.message);
      return;
    }
    this.activity = _data.data.data;
    this.now_timestamp = ~~(+new Date() / 1000);
    if (this.now_timestamp < this.activity.start_time) {
      this.activity.activity_status = '未开始';
    } else {
      if (this.now_timestamp < this.activity.end_time) {
        this.activity.activity_status = '进行中';
      } else {
        this.activity.activity_status = '已结束';
      }
    }
  }

  // 获取概况信息
  async getGeneralSituationInfo(page: any, level: any) {
    this.is_loading = true;
    this.general_situation_page = page;
    this.level = level;
    const _data = await this.$axios.get(
      `${API.general_situation}?activity_id=${this.activity_id}&page=${page}&clerk_level=${level}`,
    );
    this.is_loading = false;
    if (_data.status !== 200) {
      this.$message.error(_data.data.message);
      return;
    }
    this.general_situation_data = _data.data.data;
  }

  // 获取概况总计信息
  async getTotalInfo(clerk_level: any) {
    this.is_loading = true;
    this.level = clerk_level;
    const _data = await this.$axios.get(
      `${API.total_general_situation}${this.activity_id}`,
      {
        params: {
          activity_id: this.activity_id,
          clerk_level,
        },
      },
    );
    this.is_loading = false;
    if (_data.status !== 200) {
      this.$message.error(_data.data.message);
      return;
    }
    if (this.general_situation_data.data.length > 0) {
      const total_obj = {
        id: uuidv4(),
        clerk_name: '合计',
        live_view: _data.data.data.live_view,
        live_apply_view: _data.data.data.live_apply_view,
        live_apply_no_view: _data.data.data.live_apply_no_view,
        live_no_apply_view: _data.data.data.live_no_apply_view,
        parent_clerk_name: '',
      };
      if (this.level === '2') {
        total_obj.clerk_name = '-';
        total_obj.parent_clerk_name = '合计';
      }
      this.general_situation_data.data.push(total_obj);
    }
  }

  // 导出概况信息
  exportData() {
    let url = '';
    url = API.export;
    window.location.href = getUrl(url, {
      activity_id: this.activity_id,
      clerk_level: this.level,
      is_export: 1,
    });
  }

  // 选择时刻
  selectMoment() {
    if (this.moment && this.moment.length > 0) {
      this.getSignUpInfo();
    } else {
      this.detail_data = getPagingData();
    }
  }

  // 导出报名用户信息
  exportSignUpData() {
    if (this.moment[0] && this.moment[1]) {
      const url = API.export_sign;
      window.location.href = getUrl(url, {
        activity_id: this.activity_id,
        start_time: this.moment[0].format('X'),
        end_time: this.moment[1].format('X'),
        is_export: 1,
      });
    } else {
      this.$message.error('请选择日期');
    }
  }

  // 获取报名用户观看明细
  async getSignUpInfo(page: any = 1) {
    this.is_loading = true;
    this.sign_up_page = page;
    const _data = await this.$axios.get(`${API.sign_up}`, {
      params: {
        activity_id: this.activity_id,
        page: this.sign_up_page,
        start_time: this.moment[0] ? this.moment[0].format('X') : '',
        end_time: this.moment[1] ? this.moment[1].format('X') : '',
      },
    });
    this.is_loading = false;
    if (_data.status !== 200) {
      this.$message.error(_data.data.message);
      return;
    }
    this.detail_data = _data.data.data;
  }
  async created() {
    if (this.$route.query.activity_id) {
      this.activity_id = String(this.$route.query.activity_id);
    }
    await this.getActivityInfo();
    await this.getGeneralSituationInfo(this.general_situation_page, this.level);
    await this.getTotalInfo(this.level);
    const res = await this.$axios.get(API.get_setting_info);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.setting_info = getSettingInfo(res.data.data);
  }
}
